module.exports = __webpack_public_path__ + "img/u_picture.681dc308.png";